@if (sensorData) {
  <div class="align-items-center grid gap-1">
    <div class="sensor-wrapper" [class.border-danger]="sensorData.sensor1.hasDeviation">
      <div
        class="sensor d-flex flex-column align-items-center text-white py-2"
        [class.bg-danger]="sensorData.sensor1.hasDeviation"
      >
        <span>{{ sensorData.sensor1.label }}</span>
        <span>{{ sensorData.sensor1.value | number: '1.0-0' }}</span>
      </div>
    </div>
    <div class="sensor-wrapper" [class.border-danger]="sensorData.sensor2.hasDeviation">
      <div
        class="sensor d-flex flex-column align-items-center text-white py-2"
        [class.bg-danger]="sensorData.sensor2.hasDeviation"
      >
        <span>{{ sensorData.sensor2.label }}</span>
        <span>{{ sensorData.sensor2.value | number: '1.0-0' }}</span>
      </div>
    </div>
    <div class="sensor-wrapper" [class.border-danger]="sensorData.sensor3.hasDeviation">
      <div
        class="sensor d-flex flex-column align-items-center text-white py-2"
        [class.bg-danger]="sensorData.sensor3.hasDeviation"
      >
        <span>{{ sensorData.sensor3.label }}</span>
        <span>{{ sensorData.sensor3.value | number: '1.0-0' }}</span>
      </div>
    </div>
  </div>
}
